import { render, staticRenderFns } from "./CategoryItemView.vue?vue&type=template&id=6ab3d352&scoped=true&"
import script from "./CategoryItemView.vue?vue&type=script&lang=js&"
export * from "./CategoryItemView.vue?vue&type=script&lang=js&"
import style0 from "./CategoryItemView.vue?vue&type=style&index=0&id=6ab3d352&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab3d352",
  null
  
)

export default component.exports